import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import TextInput from "@/components/inputs/text.vue"
  import {PropType} from "vue"
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'supplier',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<Supplier>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const value = _useModel(__props, "value")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            value: value.value.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value.value.name) = $event)),
            title: "Name",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.memorandum,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.memorandum) = $event)),
            title: "Memorandum",
            multiline: "",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})